import { cn } from '@/lib/utils.ts'
import Span from '@/components/common/textElements/Span.tsx'
import { Tip } from '@/components/common/tip/Tip.tsx'
import { BellRing } from 'lucide-react'
import { useAnimateQueueCount } from '@/components/common/menu/lib/hooks/useAnimateQueueCount.ts'

type PropsT = {
  className?: string
}

export default function NavDesktopQueueCountBtn({ className }: PropsT) {
  const { isAnimating, queueCount, isVisible } = useAnimateQueueCount()

  if (queueCount === 0) return null

  return (
    <div className={cn('ml-auto flex items-center gap-2', className)}>
      <Tip content={`W kolejce znajdują się elementy oczekujące na wysłanie.   `}>
        <BellRing
          className={cn(
            'size-[18px] text-muted-foreground transition-colors duration-300',
            isVisible ? 'text-destructive' : '',
          )}
          style={{
            transformOrigin: 'top center',
            animation: isAnimating ? 'bell-ring 0.5s ease-in-out 2' : undefined,
          }}
        />
      </Tip>
      <div
        className={cn(
          `flex h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-muted-foreground px-1.5`,
        )}
      >
        <Span
          className={`shrink-0 grow-0 font-medium leading-none`}
          size={'xxs'}
          variant={`primaryForeground`}
          text={queueCount}
        />
      </div>
    </div>
  )
}
